<script>
    import { NotificationModal } from "../../../../../Components/Common/index.svelte";

    export let isModalOpen = false,
        defaultItems = [],
        selectedItems = [],
        closeModal = () => {},
        addItem = () => {};

    $: if (defaultItems.length) _syncOptions();

    let infoObj = {},
        filteredItems = [],
        infoSubRegionOptions = [];

    const infoRegionOptions = [],
        infoRegionMap = new Map();

    const closeSelector = () => {
        infoObj = {
            region: "",
            subRegion: "",
        };

        handleRegionChange();

        closeModal();
    };

    const handleRegionChange = (isRegionChange = true) => {
        if (isRegionChange) infoObj.subRegion = "";

        if (!infoObj.region) filteredItems = [];
        else {
            infoSubRegionOptions = Array.from(
                infoRegionMap.get(infoObj.region),
            );

            if (!infoObj.subRegion)
                filteredItems = defaultItems.filter(
                    (item) => item.infoRegion == infoObj.region,
                );
            else
                filteredItems = defaultItems.filter(
                    (item) =>
                        item.infoRegion == infoObj.region &&
                        item.infoSubRegion == infoObj.subRegion,
                );
        }
    };

    // HELPER FUNCTIONS
    const _syncOptions = () => {
        defaultItems.map((item) => {
            if (item.infoRegion && !infoRegionOptions.includes(item.infoRegion))
                infoRegionOptions.push(item.infoRegion);

            if (infoRegionMap.has(item.infoRegion))
                infoRegionMap.get(item.infoRegion).add(item.infoSubRegion);
            else
                infoRegionMap.set(
                    item.infoRegion,
                    new Set([item.infoSubRegion]),
                );
        });
    };
</script>

<NotificationModal
    {isModalOpen}
    title="Select surgery item"
    closeModal={closeSelector}
    showConfirmBtn={false}
    closeModalFunction={closeSelector}
>
    <div class="flex flex-col gap-y-2 h-72">
        <div class="flex items-center gap-x-2">
            <select
                class="select select-sm select-bordered flex flex-1"
                bind:value={infoObj.region}
                on:change={handleRegionChange}
            >
                <option value="" selected disabled>Select Region</option>
                {#each infoRegionOptions as option}
                    <option value={option}>
                        {option}
                    </option>
                {/each}
            </select>

            <select
                class="select select-sm select-bordered flex flex-1"
                bind:value={infoObj.subRegion}
                on:change={() => handleRegionChange(false)}
                disabled={!infoObj.region}
            >
                <option value="" selected>Select Sub-region</option>
                {#each infoSubRegionOptions as option}
                    <option value={option}>
                        {option}
                    </option>
                {/each}
            </select>
        </div>

        {#if !filteredItems.length}
            <div class="flex flex-1 items-center justify-center text-lg">
                No possible items
            </div>
        {:else}
            <div class="flex flex-col flex-1 gap-y-1 overflow-y-auto">
                {#each filteredItems as item}
                    <div
                        class="flex flex-1 items-center justify-between gap-x-4"
                    >
                        <div class="flex flex-col w-3/4">
                            <p class="text-xs">
                                {item.infoRegion}: {item.infoSubRegion}
                            </p>
                            <p class="text-md font-bold">
                                {item.infoShortTitle} ({item.basicUnits})
                            </p>
                        </div>

                        <button
                            class={`w-8 h-8 rounded-full text-[16px] text-[#fff] ${
                                selectedItems.some((itm) => itm.id == item.id)
                                    ? "hidden"
                                    : "bg-secondary"
                            }`}
                            on:click|preventDefault={() => addItem(item)}
                        >
                            <i
                                class={`fa-solid ${
                                    selectedItems.some(
                                        (itm) => itm.id == item.id,
                                    )
                                        ? "fa-minus"
                                        : "fa-plus"
                                }`}
                            />
                        </button>
                    </div>

                    <hr />
                {/each}
            </div>
        {/if}
    </div>
</NotificationModal>
